import { ThemeConfig, extendTheme } from '@chakra-ui/react'
import { colors } from './foundations/colors/forLight'
import { components } from './components'
import { foundations } from './foundations'
import { shadows } from './foundations/shadows/forLight'
import { semanticTokens } from './semanticTokens'
import { styles } from './styles'

const config: ThemeConfig = {
  cssVarPrefix: 'hb',
  initialColorMode: 'light',
  useSystemColorMode: false,
}

const storybookOptions = {
  background: '#fbfbfb',
}

// chakra-cli requires a default export or a *theme* named export
export const theme = extendTheme({
  name: 'light',
  components,
  config,
  storybookOptions,
  ...foundations,
  colors: {
    ...colors,
    brand: colors.pink,
    primary: colors.blue,
    success: colors.green,
    warning: colors.orange,
    danger: colors.red,
    neutral: colors.gray,
    'alert-error': colors.red,
    'alert-info': colors.blue,
    'alert-success': colors.green,
    'alert-warning': colors.orange,
    'text-brand': colors.pink['500'],
    'text-primary': colors.blue['500'],
    'text-success': colors.green['500'],
    'text-warning': colors.orange['500'],
    'text-danger': colors.red['500'],
    'text-neutral-50': colors.gray['50'],
    'text-neutral-100': colors.gray['100'],
    'text-neutral-200': colors.gray['200'],
    'text-neutral-300': colors.gray['300'],
    'text-neutral-400': colors.gray['400'],
    'text-neutral-500': colors.gray['500'],
    'text-neutral-600': colors.gray['600'],
    'text-neutral-700': colors.gray['700'],
    'text-neutral-800': colors.gray['800'],
    'text-neutral-900': colors.gray['900'],
  },
  shadows,
  semanticTokens,
  styles,
})
